import ky from "ky";

import { BASE_URL } from "./constants/index";
import { emptyBodyHook } from "./hooks/(beforeRequest)/emptyBody";
import { envelopeHook } from "./hooks/(afterResponse)/envelope";
import { errorShapeHook } from "./hooks/(beforeError)/errorShape";

// Shared base: envelope unwrap + error normalization only.
// No loader, no auth, no token refresh — safe to import from any hook file.
//
// retry config — two competing requirements:
//   1. No automatic retries: axios had zero automatic retries; all retries were
//      intentional application-level logic. methods:[] satisfies this — ky's
//      #calculateRetryDelay checks the method allowlist before status codes or
//      network errors, so no method ever passes and no auto-retry fires.
//   2. ky.retry() from afterResponse hooks must work: hooks call ky.retry() to
//      re-issue a request after token refresh. ky converts this to a
//      ForceRetryError which bypasses the methods check — but NOT the
//      retryCount >= limit check. limit:0 (retry:0) causes 0>=0 → throws
//      before the forced retry executes, silently dropping the retried request.
//      limit:1 allows exactly one forced retry while keeping auto-retries dead.
export const base = ky.create({
  hooks: {
    afterResponse: [envelopeHook],
    beforeError: [errorShapeHook],
    beforeRequest: [emptyBodyHook],
  },
  prefix: BASE_URL,
  retry: { limit: 1, methods: [] },
  throwHttpErrors: true,
});
